interface YoutubeProps {
  width?: string;
  height?: string;
  color?: string;
  innerColor?: string;
  className?: string;
}

export const Youtube = ({
  width = '31',
  height = '30',
  color = 'white',
  innerColor = 'none',
  className,
}: YoutubeProps) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 31 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1_19958)">
        <rect
          className={className}
          x="8.91797"
          y="8.03613"
          width="13.15"
          height="11.6889"
          fill={innerColor}
        />
        <path
          d="M29.4589 7.21878L29.4954 7.45743C29.1423 6.20453 28.1889 5.23776 26.9774 4.88587L26.9518 4.87978C24.6737 4.26125 15.5065 4.26125 15.5065 4.26125C15.5065 4.26125 6.36234 4.24907 4.06109 4.87978C2.82645 5.23776 1.87186 6.20453 1.52484 7.43186L1.51875 7.45743C0.667657 11.9029 0.661569 17.2444 1.5565 22.004L1.51875 21.7629C1.87186 23.0158 2.82523 23.9826 4.03674 24.3345L4.06231 24.3406C6.33799 24.9603 15.5077 24.9603 15.5077 24.9603C15.5077 24.9603 24.6506 24.9603 26.953 24.3406C28.1889 23.9826 29.1435 23.0158 29.4905 21.7885L29.4966 21.7629C29.8838 19.6955 30.1054 17.3163 30.1054 14.886C30.1054 14.7971 30.1054 14.707 30.1042 14.6169C30.1054 14.5341 30.1054 14.4355 30.1054 14.3368C30.1054 11.9053 29.8838 9.52612 29.4589 7.21878ZM12.5818 19.0562V10.1763L20.2112 14.623L12.5818 19.0562Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0_1_19958">
          <rect
            className={className}
            width="29.2222"
            height="29.2222"
            fill="white"
            transform="translate(0.882812)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
